import React, {useState} from 'react'
import IIsh from '../../videos/video.mp4'
import { HeroContainer, HeroBg, VideoBg, HeroContent, HeroH1, HeroP, HeroBtnWrapper, ArrowForward, ArrowRight} from './HeroElements';
import {Button} from '../ButtonElement';





const HeroSection = () => {
    const [hover, setHover] = useState(false)

    const onHover = () =>{
        setHover(!hover);
    }
    return (
        <HeroContainer id='hero'>
            <HeroBg>
                <VideoBg autoPlay playsInline loop muted src={IIsh} type= "video/mp4" />
            </HeroBg>
            <HeroContent>
                <HeroH1>Virtual Banking Made Easy</HeroH1>
                <HeroP>
                    Sign up for a new account today and receive $250 in credit towards your next payment.
                </HeroP>
                <HeroBtnWrapper>
                    <Button smooth={true} duration={500} 
                            spy={true}
                            exact="true"  to="signup" onMouseEnter = {onHover} onMouseLeave = {onHover} primary = {1} dark = {1}>
                        Get Started {hover ? <ArrowForward /> : <ArrowRight />}
                    </Button>
                </HeroBtnWrapper>
            </HeroContent>
        </HeroContainer>
    )
}
//commeent
export default HeroSection;